// extracted by mini-css-extract-plugin
export var animationContainer = "_gy-0";
export var asteriskIcon = "_gy-8";
export var conversationLeftSection = "_gy-4";
export var conversationListItem = "_gy-3";
export var conversationMiddleSection = "_gy-5";
export var conversationRightSection = "_gy-6";
export var detailsContent = "_gy-1";
export var listContainer = "_gy-7";
export var modalContent = "_gy-2";